export enum WarehouseItemWorkRequestStatus {
  Pending = "pending",
  InProgress = "in_progress",
  Completed = "completed",
  Cancelled = "cancelled",
  Rejected = "rejected",
}
